module.exports = __webpack_public_path__ + "static/media/raixer-icon-white.00859af4.png";